import { DispatchCircuitRule } from "@/core/models/dispatchCircuitRule";
import { ShippingMethod } from "@/apps/shared/proposal/core/domain/model/ShippingMethod";
import { PaymentMethod } from "@/apps/shared/proposal/core/domain/model/PaymentMethod";
import { ImpactPriceEntry } from "@/apps/shared/proposal/core/infrastructure/legacy/ImpactPriceEntry";
import {
  getModifiersAmountAsDecimal,
  getTotalPriceAsDecimal,
} from "@/apps/shared/proposal/core/domain/service/totalPriceCalculator";
import { Declaration } from "@/apps/shared/buyback/core/domain/model/declaration/Declaration";
import { Bonus } from "@/apps/shared/buyback/core/domain/model/bonus/bonus";

export class BuybackInCart {
  public readonly inCartId: string;
  public readonly estimatedPrice: number;
  public readonly transportMode: DispatchCircuitRule;
  public readonly shippingMethod: ShippingMethod;
  public readonly paymentMode: PaymentMethod;
  public readonly impactPriceEntries: ImpactPriceEntry[];
  public warehouseId: string | null;
  public readonly declaration: Declaration;
  public readonly bonus: Bonus | null;

  constructor(
    inCartId: string,
    estimatedPrice: number,
    transportMode: DispatchCircuitRule,
    shippingMethod: ShippingMethod,
    paymentMode: PaymentMethod,
    impactPriceEntries: ImpactPriceEntry[],
    warehouseId: string | null = null,
    declaration: Declaration,
    bonus: Bonus | null = null
  ) {
    this.inCartId = inCartId;
    this.estimatedPrice = estimatedPrice;
    this.transportMode = transportMode;
    this.shippingMethod = shippingMethod;
    this.paymentMode = paymentMode;
    this.impactPriceEntries = impactPriceEntries;
    this.warehouseId = warehouseId;
    this.declaration = declaration;
    this.bonus = bonus;
  }

  getTransportMode(): DispatchCircuitRule {
    return this.transportMode;
  }

  getPaymentMode(): PaymentMethod {
    return this.paymentMode;
  }

  setWarehouseId(warehouseId: string): void {
    this.warehouseId = warehouseId;
  }

  getWarehouseId(): string | null {
    if (this.warehouseId) {
      return this.warehouseId;
    }

    return null;
  }

  getDeclaration(): Declaration {
    return this.declaration;
  }

  getTotalPriceAsDecimal(): number {
    return getTotalPriceAsDecimal(this.estimatedPrice, this.paymentMode, this.shippingMethod, this.bonus);
  }

  getModifiersAmountAsDecimal(): number {
    return getModifiersAmountAsDecimal(this.estimatedPrice, this.paymentMode, this.shippingMethod);
  }

  getBonus(): Bonus | null {
    return this.bonus;
  }
}
